import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SharedAlertData } from './alert-data.model';

@Component({
    templateUrl: './alert-modal.template.html'
})
export class SharedAlertModalComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: SharedAlertData) {}
}
